export const SET_LOADING = (state, value) => {
  state.loading = value
}

export const SET_HEIGHT = (state, value) => {
  state.height = value
}

export const SET_SHOW_MENUS = (state, value) => {
  state.showMenus = value
}

export const SET_SHOW_MINIMAL_HEADER = (state, value) => {
  state.showMinimalHeader = value
}
